import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountCloseInfoPage} from '../../../../../../features/loans/pages/LoanAccountClosePage/LoanAccountCloseInfoPage';

export const Route = createFileRoute(
  '/_protected/accounts/loans/$accountId/close/',
)({
  component: LoanAccountCloseInfoPage,
});
